import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  image?: string;
}
const TestimonialCard = ({
  quote,
  author,
  image
}: TestimonialProps) => <motion.div whileHover={{
  y: -5
}} className="bg-white rounded-xl border border-border shadow-sm overflow-hidden flex flex-col" data-id="element-207">
    {image && <img src={image} alt={`Photo from ${author}`} loading="lazy" className="w-full h-64 object-cover" data-id="element-208" />}
    <div className="p-8 flex flex-col flex-grow" data-id="element-209">
      <div className="flex mb-4" data-id="element-210">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold fill-gold" data-id="element-211" />)}
      </div>
      <p className="text-ink italic mb-6 text-base md:text-lg leading-relaxed flex-grow" data-id="element-212">
        "{quote}"
      </p>
      <div data-id="element-213">
        <p className="font-heading font-bold text-navy" data-id="element-214">{author}</p>
      </div>
    </div>
  </motion.div>;
export function Testimonials() {
  const testimonials = [{
    quote: "I was scared my son was falling behind because he couldn't sit still for more than 3 minutes. After just 14 days with Megapack Neuro-Kid™, he went from 3 minutes of focus to completing full 20-minute sessions completely on his own — and asking for more.",
    author: 'Jessica M. — Mom of a 7-year-old, Texas',
    image: 'https://cdn.magicpatterns.com/uploads/dkn2S3EX2fF5bwnU2NWtXP/ChatGPT_Image_29_jun_2026,_02_10_18_p.m..png'
  }, {
    quote: 'The Focus Warriors tome changed everything for my daughter. She used to cry and quit the moment something felt hard. After just 2 weeks, she now pushes through every challenge and finishes every single activity. That shift in her confidence is something no app could ever give her.',
    author: 'Amanda K. — Mom of an 8-year-old, Florida',
    image: 'https://cdn.magicpatterns.com/uploads/qWShBjuSxQRoD6i1B4nuMz/ChatGPT_Image_29_jun_2026,_02_14_21_p.m..png'
  }, {
    quote: 'I printed the 30-Day Planner and put it on the fridge. By day three my kids were reminding ME to print the activity. In 6 years of parenting I have never experienced anything like that with any product I have ever bought for them.',
    author: 'Rachel T. — Mom of two kids (ages 6 & 9), California',
    image: 'https://cdn.magicpatterns.com/uploads/5MBhAa2XvPRBa9j7oKd2UU/ChatGPT_Image_29_jun_2026,_02_19_28_p.m..png'
  }, {
    quote: 'I never thought a $19 product would transform my evenings. We went from 45 minutes of iPad battles every night to 10 minutes of calm focused activity. No more guilt. No more arguments. Just two very proud kids. Easily the best purchase I have made this entire year.',
    author: 'Michelle P. — Mom of a 9-year-old, New York',
    image: 'https://cdn.magicpatterns.com/uploads/xdZSmExvz7RV8WGTzKTKke/ChatGPT_Image_29_jun_2026,_02_21_58_p.m..png'
  }];
  return <section className="bg-lightgray py-16 px-4 border-y border-border" data-id="element-215">
      <div className="max-w-6xl mx-auto" data-id="element-216">
        <h2 className="text-3xl md:text-4xl font-heading font-black text-center text-navy mb-12" data-id="element-217">
          ❤️ WHAT PARENTS WHO ALREADY HAVE IT SAY
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-218">
          {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-219" />)}
        </div>
      </div>
    </section>;
}